@if (IsLoading) {
  <app-loading-page [message]="'Loading instances'"></app-loading-page>
}
@else {
  <div class="page">
    <h2>Instances</h2>
    <div class="grid-wrapper">
      <kendo-grid class="instance-table" [data]="instances" (cellClick)="onCellClick($event)">
        <kendo-grid-column field="Name">
        </kendo-grid-column>
        <kendo-grid-column field="Description">
        </kendo-grid-column>
        <kendo-grid-column field="Status">
        </kendo-grid-column>
        <kendo-grid-column field="ID">
        </kendo-grid-column>
        <kendo-grid-column field="__mj_CreatedAt" title="Created">
        </kendo-grid-column>
        <!-- <kendo-grid-column title="Actions">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button kendoButton (click)="selectInstance(dataItem)">Details</button>
          </ng-template>
        </kendo-grid-column> -->  
      </kendo-grid> 
    </div>
  </div>
}